import { withCache } from '@/utils';
import { fetchAnalysisDetail, fetchAnalysisHistory } from '@/utils/api';

import { BiasAnalysisDetail, BiasAnalysisRecord } from '@/types/common';

/**
 * Fetch recent bias analysis history from the backend
 * @param limit Maximum number of records to retrieve (default: 10)
 * @param bypassCache Whether to bypass the cache
 * @returns List of bias analysis records
 */
export async function getAnalysisHistory(
    limit: number = 10,
    bypassCache: boolean = true
): Promise<BiasAnalysisRecord[]> {
    return withCache<BiasAnalysisRecord[]>(
        'getAnalysisHistory',
        { limit },
        async () => {
            try {
                return await fetchAnalysisHistory(limit);
            } catch (error) {
                console.error('Failed to fetch analysis history:', error);
                throw new Error('Failed to fetch analysis history');
            }
        },
        { bypassCache }
    );
}

/**
 * Fetch a specific bias analysis by ID
 * @param analysisId The ID of the analysis to retrieve
 * @param bypassCache Whether to bypass the cache
 * @returns The detailed bias analysis record
 */
export async function getAnalysisDetail(
    analysisId: number,
    bypassCache: boolean = false
): Promise<BiasAnalysisDetail> {
    return withCache<BiasAnalysisDetail>(
        'getAnalysisDetail',
        { analysisId },
        async () => {
            try {
                return await fetchAnalysisDetail(analysisId);
            } catch (error) {
                console.error(
                    `Failed to fetch analysis detail for ID ${analysisId}:`,
                    error
                );
                throw new Error(
                    `Failed to fetch analysis detail for ID ${analysisId}`
                );
            }
        },
        { bypassCache }
    );
}
